import * as types from './types';

const getters = {
  [types.GET_PUBLISHER_BY_ID]: (state, context, rootState) => (id) => {
    const { publisherList } = rootState.campaigns;
    return publisherList.find((publisher) => publisher.id === id);
  },

  [types.GET_TEMPLATE_BY_ID]: (state, context, rootState) => (id) => {
    const { availableTemplates } = rootState.templates;
    return availableTemplates.find((template) => template.id === id);
  },

  [types.GET_TEMPLATE_BY_CREATIVE_ID]: (state, context, rootState) => (creativeId) => {
    const creative = rootState.content.creatives.find((c) => c.id === creativeId);
    return context.GET_TEMPLATE_BY_ID(creative?.creativeTemplateId);
  },

  [types.GET_REGION_BY_ID]: (state, context, rootState) => (id) => {
    const { regions } = rootState.campaigns;
    return regions.find((region) => region.id === id);
  },

  [types.GET_COUNTRY_BY_ID]: (state, context, rootState) => (id) => {
    const { countries } = rootState.campaigns;
    return countries[id];
  },

  [types.GET_PARSED_FILE_RESULT_WITH_COMBINATIONS]: (state) => {
    const list = state.parsedFileResult
      .map((item) => ({
        geoIndex: null,
        creativeIndex: null,
        publisherIndex: null,
        ...item,
      }));
    return list;
  },

  [types.GET_COUNTRYS_BY_IDS]: (state, context, rootState) => (ids) => {
    if (!ids || !Array.isArray(ids)) return 'ALL';
    if (ids.length === 0) return 'ALL';
    const { countries } = rootState.campaigns;
    return ids.map((id) => countries[id]).join();
  },

  [types.GET_GEOS_BY_IDS]: (state, context, rootState) => (ids) => {
    if (!ids || !Array.isArray(ids)) return 'ALL';
    if (ids.length === 0) return 'ALL';
    const { regionsMap } = rootState.campaigns;
    return ids.map((id) => regionsMap.get(id).name).join();
  },

  [types.GET_ALL_COMBINATIONS]: (state, context, rootState) => {
    const selectedCreatives = rootState.content.activeCreatives;
    const { publisherIds } = rootState.campaigns.order;
    const { regions } = rootState.campaigns.order.geoTargeting;
    const { inclusions } = rootState.campaigns.order.geoTargeting.countryInclusionsExclusions;

    const publisherList = [
      { value: null, disabled: true, name: 'Publishers' },
      { id: null, name: 'All Publishers' },
      ...publisherIds.map((publisherId) => context.GET_PUBLISHER_BY_ID(publisherId)),
    ];
    const creativesList = [
      { value: null, disabled: true, name: 'Creatives' },
      { id: null, name: 'All Creatives' },
      ...Object.keys(selectedCreatives).map((key) => ({
        id: selectedCreatives[key].id,
        name: selectedCreatives[key].name,
      })),
    ];
    const geoList = [
      { value: null, disabled: true, name: 'Geo\'s' },
      { id: null, type: null, name: 'All Geo\'s' },
      ...regions.map((regionId) => ({ ...context.GET_REGION_BY_ID(regionId), type: 'region' })),
      ...inclusions.map((countryId) => ({ id: countryId, name: context.GET_COUNTRY_BY_ID(countryId), type: 'country' })),
    ];

    function getOptions(array) {
      if (!array || !Array.isArray(array)) throw new Error('valid array needs to be passed.');
      return array.flatMap((item, index) => ({
        disabled: item?.hasOwnProperty('disabled') ? item.disabled : false,
        value: index === 0 ? null : index,
        id: item?.id,
        type: item?.type,
        text: item?.name,
      }));
    }
    const creatives = getOptions(creativesList);
    const publishers = getOptions(publisherList);
    const geos = getOptions(geoList);

    return {
      creatives,
      publishers,
      geos,
    };
  },
  [types.GET_GROUPED_TRACKERS_LIST]: (state) => state.groupedTrackersList,
};

export default getters;
